import { render, staticRenderFns } from "./OFlatpickrWrapper.vue?vue&type=template&id=397b4632&scoped=true&"
import script from "./OFlatpickrWrapper.vue?vue&type=script&lang=js&"
export * from "./OFlatpickrWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397b4632",
  null
  
)

export default component.exports